import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenCardComponent } from "./components/loren-card/loren-card.component";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";

import { TranslocoModule } from "@jsverse/transloco";

@NgModule({
  declarations: [LorenCardComponent],
  imports: [CommonModule, MatCardModule, MatIconModule, TranslocoModule],
  exports: [LorenCardComponent],
})
export class LorenCardModule {}
